/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface EventIdentifiers
 */
export interface EventIdentifiers {
    /**
     * 
     * @type {EventName}
     * @memberof EventIdentifiers
     */
    event_name: EventName;
}



/**
 * Check if a given object implements the EventIdentifiers interface.
 */
export function instanceOfEventIdentifiers(value: object): value is EventIdentifiers {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}

export function EventIdentifiersFromJSON(json: any): EventIdentifiers {
    return EventIdentifiersFromJSONTyped(json, false);
}

export function EventIdentifiersFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventIdentifiers {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
    };
}

export function EventIdentifiersToJSON(json: any): EventIdentifiers {
    return EventIdentifiersToJSONTyped(json, false);
}

export function EventIdentifiersToJSONTyped(value?: EventIdentifiers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
    };
}

